module.exports = __webpack_public_path__ + "img/Garde-corps réalisé sur mesure..c34421dc.jpg";